import { useRouteError } from "react-router-dom";
import { Alert } from "react-daisyui";
export default function ErrorPage() {
  const error: any = useRouteError();
  console.log(error);

  let errorStatusMessage
  let errorMessage;

  if (error.response && error.response.status) {
    switch (error.response.status) {
      case 401:
        errorStatusMessage = `${error.message}`
        errorMessage = `Unauthorized! Please log in.`;
        break;
      case 403:
        errorStatusMessage = `${error.message}`
        errorMessage = `Forbidden! You don't have permission to access this. Please login as an admin user.`;
        break;
      default:
        errorMessage = error.statusText || error.message;
    }
  } else {
    errorMessage = error.message;
  }
  

  return (
    <div id="error-page" className="w-1/2 mr-auto ml-auto">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p className="mt-4">
        <Alert status="error" icon={<svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>}>
          {errorStatusMessage} <br />
          {errorMessage}
        </Alert>
      </p>
    </div>
  );
}
